import { isValid as isDateValid, parse as dateParse } from "date-fns";
import capitalize from "lodash-es/capitalize";
import isObjectLike from "lodash-es/isObjectLike";
import { type ClassValue, clsx } from "clsx";

import { twMerge } from "tailwind-merge";

export * as dateUtils from "./dates";

export function azureConfigSet() {
  const runtimeConfig = useRuntimeConfig();
  return (
    runtimeConfig.public.azureADClientId && runtimeConfig.public.azureADTenantId
  );
}

export function stripAllQuotes(value: string) {
  return value.replaceAll('"', "");
}

export function isEmail(email: string) {
  const emailRegex =
    /^[a-zA-Z0-9\-._]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?$/;

  if (email && emailRegex.test(email)) {
    return true;
  }
  return false;
}

export function isDateString(value: string, format = "") {
  try {
    if (format) {
      return isDateValid(dateParse(value, format, new Date()));
    }

    return isDateValid(new Date(value));
  } catch {
    return false;
  }
}

export function getInitials(name: string) {
  return name
    .split(" ")
    .map((n) => n[0]?.toUpperCase())
    .join("");
}

export function capitalizeWords(name?: string) {
  if (!name) return "";
  const words = String(name).split(" ");
  return words
    .map((word) => capitalize(word))
    .join(" ")
    .trim();
}

export function unRefObjectKeys<T extends {}>(obj: {
  [key in keyof T]: MaybeRef<T[keyof T]>;
}) {
  if (!isObjectLike) return undefined;
  return Object.keys(obj).reduce((acc, key) => {
    const value = toValue(obj[key as keyof T]) as T[keyof T];
    acc[key as keyof T] = value;
    return acc;
  }, {} as T);
}

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function doNothing(..._args: unknown[]) {}

export function logger(...args: unknown[]) {
  console.log(...args);
}

export function Promiser() {
  return Promise;
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
